import React, { useRef, useEffect } from "react";
import MediaDisplay from "./MediaDisplay";

const ParticipantPreviewCarousel = ({ 
  participants, 
  currentIndex, 
  onParticipantSelect, 
  t, 
  isQuadMode 
}) => {
  const carouselRef = useRef(null);

  useEffect(() => {
    // Прокручиваем карусель к текущему участнику
    if (carouselRef.current) {
      const currentElement = carouselRef.current.querySelector(`[data-index="${currentIndex}"]`);
      if (currentElement) {
        currentElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [currentIndex]);

  return (
    <div className={`participant-preview-carousel ${isQuadMode ? 'quad-mode' : 'single-mode'}`}>
      <div className="carousel-container" ref={carouselRef}>
        {participants.map((participant, index) => {
          const firstMedia = participant.media_pairs[0];
          const isActive = index === currentIndex;
          
          return (
            <div
              key={participant.id}
              data-index={index}
              className={`participant-preview-card ${isActive ? 'active' : ''}`}
              onClick={() => onParticipantSelect(index)}
            >
              <div className="preview-media-section">
                <div className="preview-media-before">
                  {firstMedia?.before_url ? (
                    <MediaDisplay
                      url={firstMedia.before_url}
                      contentType={firstMedia.before_content_type}
                      label={t.before}
                      className="preview-media-content"
                    />
                  ) : (
                    <div className="no-media-preview">{t.no_media || 'Нет медиа'}</div>
                  )}
                </div>
                <div className="preview-media-after">
                  {firstMedia?.after_url ? (
                    <MediaDisplay
                      url={firstMedia.after_url}
                      contentType={firstMedia.after_content_type}
                      label={t.after}
                      className="preview-media-content"
                    />
                  ) : (
                    <div className="no-media-preview">{t.no_media || 'Нет медиа'}</div>
                  )}
                </div>
              </div>
              
              <div className="preview-info-section">
                <div className="preview-participant-last-name">
                  {participant.user.last_name}
                </div>
                <div className="preview-participant-first-name">
                  {participant.user.first_name}
                </div>
                {participant.has_scores && (
                  <>
                    <div className="preview-total-score-label">
                      {t.total_score}:
                    </div>
                    <div className="preview-total-score-value">
                      {Number(participant.result_score).toFixed(2)}
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ParticipantPreviewCarousel;